/* ==========================================================================
   BunaRău – JavaScript temă (fără dependențe)
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };

  /* ---------- Utilitare ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // Formatare preț după formatul Shopify (ex. "{{amount_with_comma_separator}} lei")
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} lei';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Înălțime antet (pentru elemente sticky) ---------- */
  function setHeaderHeight() {
    var h = $('.header-wrapper--sticky');
    document.documentElement.style.setProperty('--header-h', h ? h.offsetHeight + 'px' : '0px');
  }

  /* ---------- Drawer-e (meniu mobil, filtre) ---------- */
  function openDrawer(el) { el.classList.add('is-open'); document.body.classList.add('no-scroll'); var f = $('button, a, input', el); if (f) f.focus(); }
  function closeDrawer(el) { el.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { var d = document.getElementById(opener.getAttribute('data-drawer-open')); if (d) { e.preventDefault(); openDrawer(d); } return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { var dr = closer.closest('.drawer'); if (dr) closeDrawer(dr); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Căutare în antet ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var box = document.getElementById('HeaderSearch');
    if (!box) return;
    box.hidden = !box.hidden;
    t.setAttribute('aria-expanded', String(!box.hidden));
    if (!box.hidden) { var i = $('input', box); if (i) i.focus(); }
  });

  /* ---------- Dropdown-uri meniu desktop: închidere la click în afară ---------- */
  document.addEventListener('click', function (e) {
    $$('.nav__dropdown[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Bară anunț rotativă ---------- */
  function initAnnouncements() {
    $$('[data-announcements]').forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0, delay = parseInt(bar.getAttribute('data-speed') || '5', 10) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    });
  }

  /* ---------- Numărătoare inversă (Drop nou) ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      var timer = $('.drop__timer', el), live = $('.drop__live', el);
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (timer) timer.hidden = true;
          if (live) live.hidden = false;
          $$('[data-after-drop]', el).forEach(function (x) { x.hidden = false; });
          $$('[data-before-drop]', el).forEach(function (x) { x.hidden = true; });
          return false;
        }
        var s = Math.floor(diff / 1000);
        var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(map).forEach(function (k) { var n = $('[data-unit="' + k + '"]', el); if (n) n.textContent = pad(map[k]); });
        return true;
      }
      if (tick()) { var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
    });
  }

  /* ---------- Contor coș în antet ---------- */
  function refreshCartCount() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = document.getElementById('CartToast');
    if (!el) return;
    $('.toast__text', el).textContent = msg;
    $('.toast__link', el).hidden = !!isError;
    el.classList.toggle('toast--error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Formular produs: variante + adăugare AJAX ---------- */
  function initProductForms() {
    $$('[data-product-section]').forEach(function (section) {
      var jsonEl = $('[data-product-json]', section);
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var form = $('form[data-product-form]', section);
      var idInput = form ? $('input[name="id"]', form) : null;
      var addBtn = form ? $('[data-add-to-cart]', form) : null;
      var addText = addBtn ? $('[data-add-to-cart-text]', addBtn) : null;
      var priceWrap = $('[data-price]', section);
      var skuEl = $('[data-sku]', section);
      var pickers = $$('[data-option-index]', section);
      var errorEl = $('[data-form-error]', section);

      function selectedOptions() {
        return pickers.map(function (fs) {
          var c = $('input:checked', fs);
          return c ? c.value : null;
        });
      }
      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
        });
      }
      // Marchează combinațiile indisponibile
      function markAvailability(opts) {
        pickers.forEach(function (fs, idx) {
          $$('input', fs).forEach(function (input) {
            var test = opts.slice(); test[idx] = input.value;
            var match = product.variants.find(function (v) {
              return v.options.every(function (o, i) { return o === test[i]; });
            });
            input.classList.toggle('is-unavailable', !match || !match.available);
          });
          var lbl = $('[data-selected-value]', fs);
          if (lbl) lbl.textContent = opts[idx] || '';
        });
      }
      function renderPrice(v) {
        if (!priceWrap || !v) return;
        var cur = $('.price__current', priceWrap), cmp = $('.price__compare', priceWrap), omni = $('.price__omnibus', priceWrap);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.classList.toggle('price--sale', !!onSale);
        if (cur) cur.textContent = formatMoney(v.price);
        if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = formatMoney(v.compare_at_price); }
        if (omni) {
          var fixed = omni.getAttribute('data-omnibus-fixed');
          var useCompare = omni.getAttribute('data-omnibus-fallback') === 'true';
          var tpl = omni.getAttribute('data-omnibus-template') || '';
          if (!onSale) { omni.hidden = true; }
          else if (fixed) { omni.hidden = false; }
          else if (useCompare) { omni.hidden = false; omni.textContent = tpl.replace('__PRICE__', formatMoney(v.compare_at_price)); }
          else { omni.hidden = true; }
        }
      }
      function update() {
        var opts = selectedOptions();
        var v = findVariant(opts);
        markAvailability(opts);
        if (errorEl) errorEl.hidden = true;
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addText.textContent = T.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        renderPrice(v);
        if (skuEl) skuEl.textContent = v.sku || '–';
        if (addBtn) {
          addBtn.disabled = !v.available;
          addText.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
        }
        if (v.featured_media) {
          var slide = $('[data-media-id="' + v.featured_media.id + '"]', section);
          if (slide) {
            var track = slide.parentElement;
            if (getComputedStyle(track).display === 'flex') track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        }
        if (section.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      pickers.forEach(function (fs) { fs.addEventListener('change', update); });
      if (pickers.length) markAvailability(selectedOptions());

      // Adăugare în coș fără reîncărcare
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          if (addBtn) addBtn.setAttribute('aria-busy', 'true');
          fetch(T.routes.cartAdd + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          })
            .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data.description || res.data.message || T.strings.error);
              return afterAdd();
            })
            .catch(function (err) {
              if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
              else toast(err.message, true);
            })
            .finally(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); });
        });
      }
    });
  }

  /* ---------- Galerie mobilă: puncte de navigare ---------- */
  function initGalleries() {
    $$('[data-gallery]').forEach(function (g) {
      var track = $('.gallery__track', g), dots = $$('.gallery__dot', g);
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }, { passive: true });
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () { track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' }); });
      });
    });
  }

  /* ---------- Butoane cantitate +/- ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    var input = $('input', b.closest('.qty'));
    var step = parseInt(b.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    if (input.max) next = Math.min(next, parseInt(input.max, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Coș: actualizare automată la schimbarea cantității ---------- */
  function initCart() {
    var form = $('[data-cart-form]');
    if (!form) return;
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () { form.submit(); }, 600);
    });
  }

  /* ---------- Filtre colecție / căutare ---------- */
  function initFacets() {
    $$('[data-facets-form]').forEach(function (form) {
      var live = window.matchMedia('(min-width: 990px)');
      function go() {
        var params = new URLSearchParams(new FormData(form));
        // eliminăm câmpurile goale (ex. preț necompletat)
        Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
        var sort = $('[data-sort-select]');
        if (sort && sort.value) params.set('sort_by', sort.value);
        window.location.search = params.toString();
      }
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; // prețul se aplică la Enter / buton
        if (live.matches) go();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
    });
    $$('[data-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- Recomandări produse ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      var load = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-recommendations]');
          if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
          else el.closest('.section') && (el.closest('.section').hidden = true);
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '400px 0px' });
        io.observe(el);
      } else load();
    });
  }

  /* ---------- Dialoguri (ghid mărimi) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) {
      var m = document.getElementById(o.getAttribute('data-modal-open'));
      if (m && m.showModal) { e.preventDefault(); m.showModal(); }
      return;
    }
    var c = e.target.closest('[data-modal-close]');
    if (c) { var d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close(); // click pe fundal
  });


  /* ==========================================================================
     GAMIFICATION: coș lateral, recompense, confetti, upsell, roata norocului
     ========================================================================== */
  var G = T.gamification || {};
  var drawer = document.getElementById('CartDrawer');

  function unlockedCount(root) {
    var t = $('[data-unlocked]', root || document);
    return t ? parseInt(t.getAttribute('data-unlocked'), 10) || 0 : 0;
  }
  function lastUnlockedLabel(root) {
    var on = $$('.rewards__node.is-on', root || document);
    return on.length ? on[on.length - 1].getAttribute('data-label') : '';
  }
  function getStore(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function setStore(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // Reîncarcă conținutul coșului lateral prin Section Rendering API
  function refreshDrawer() {
    if (!drawer) return refreshCartCount();
    var before = parseInt(getStore('br_unlocked') || String(unlockedCount(drawer)), 10);
    return fetch(T.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var inner = $('[data-cart-drawer-inner]', tmp);
        var target = $('[data-cart-drawer-inner]', drawer);
        if (inner && target) target.replaceWith(inner);
        var after = unlockedCount(drawer);
        setStore('br_unlocked', String(after));
        if (after > before) celebrate(lastUnlockedLabel(drawer));
        return refreshCartCount();
      });
  }
  function openCartDrawer() {
    if (!drawer) { window.location.href = T.routes.cart; return; }
    drawer.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }
  function afterAdd() {
    if (drawer && G.openDrawer) {
      return refreshDrawer().then(openCartDrawer);
    }
    toast(T.strings.added);
    return refreshDrawer();
  }
  function celebrate(label) {
    var b = drawer && $('[data-unlock-banner]', drawer);
    if (b) {
      $('[data-unlock-text]', b).textContent = (T.strings.unlocked || '') + ' ' + label;
      b.hidden = false;
    }
    if (G.confetti) confetti();
  }

  // Click pe iconița coșului → deschide coșul lateral
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-drawer-open]');
    if (o && drawer) { e.preventDefault(); refreshDrawer(); openCartDrawer(); }
  });

  // +/- în coșul lateral
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line-change'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) })
    }).then(refreshDrawer).catch(function () { b.disabled = false; });
  });

  // Adăugare rapidă din upsell („15 lei”)
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-quick-add]');
    if (!f) return;
    e.preventDefault();
    var btn = $('button', f); if (btn) btn.disabled = true;
    fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error(); return refreshDrawer(); })
      .then(function () { if (btn) btn.disabled = false; if (drawer && !drawer.classList.contains('is-open')) { if (G.openDrawer) openCartDrawer(); else toast(T.strings.added); } })
      .catch(function () { toast(T.strings.error, true); if (btn) btn.disabled = false; });
  });

  // Confetti ușor (canvas, fără biblioteci)
  function confetti() {
    var c = document.getElementById('Confetti');
    if (!c || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ctx = c.getContext('2d'), W = c.width = window.innerWidth, H = c.height = window.innerHeight;
    var colors = ['#B08D57', '#E8D3A9', '#0E0E0E', '#7A1F2B', '#FBF8F3'];
    var parts = [];
    for (var i = 0; i < 140; i++) {
      parts.push({ x: W * (0.5 + (Math.random() - 0.5) * 0.4), y: H * 0.35, vx: (Math.random() - 0.5) * 12, vy: Math.random() * -12 - 4,
        s: Math.random() * 6 + 4, r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.3, c: colors[i % colors.length] });
    }
    c.style.display = 'block';
    var start = performance.now();
    (function frame(t) {
      ctx.clearRect(0, 0, W, H);
      parts.forEach(function (p) {
        p.vy += 0.35; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2); ctx.restore();
      });
      if (t - start < 2600) requestAnimationFrame(frame); else { ctx.clearRect(0, 0, W, H); c.style.display = 'none'; }
    })(start);
  }
  window.BunaRauConfetti = confetti;

  /* ---------- Roata norocului ---------- */
  function initWheel() {
    var dlg = document.getElementById('SpinWheel');
    var dataEl = document.getElementById('WheelData');
    if (!dlg || !dataEl || !dlg.showModal) return;
    var segs = [];
    try { segs = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (segs.length < 2) return;
    function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
    var trigger = $('[data-wheel-open]');
    var svg = $('[data-wheel-svg]', dlg);
    var n = segs.length, step = 360 / n;
    var fills = ['#0E0E0E', '#FBF8F3', '#B08D57', '#F3EDE4'];
    var txt = ['#FBF8F3', '#0E0E0E', '#0E0E0E', '#0E0E0E'];
    var html = '';
    segs.forEach(function (s, i) {
      var a0 = (i * step - 90) * Math.PI / 180, a1 = ((i + 1) * step - 90) * Math.PI / 180;
      var x0 = 100 * Math.cos(a0), y0 = 100 * Math.sin(a0), x1 = 100 * Math.cos(a1), y1 = 100 * Math.sin(a1);
      var k = n % 2 && i === n - 1 ? 2 : i % 4;
      html += '<path d="M0 0 L' + x0.toFixed(2) + ' ' + y0.toFixed(2) + ' A100 100 0 ' + (step > 180 ? 1 : 0) + ' 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2) + ' Z" fill="' + fills[k] + '" stroke="#B08D57" stroke-width=".8"/>';
      var mid = i * step + step / 2;
      html += '<g transform="rotate(' + mid + ')"><text x="0" y="-62" text-anchor="middle" font-size="9.5" font-weight="700" fill="' + txt[k] + '" font-family="inherit" letter-spacing=".5">' + s.label.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</text></g>';
    });
    html += '<circle r="104" fill="none" stroke="#B08D57" stroke-width="3"/><circle r="16" fill="#0E0E0E" stroke="#B08D57" stroke-width="2"/>';
    svg.innerHTML = html;

    var done = ls('br_wheel_won');
    function showResult(seg) {
      $('[data-wheel-form]', dlg).hidden = true;
      var r = $('[data-wheel-result]', dlg); r.hidden = false;
      $('[data-wheel-prize]', dlg).textContent = seg.label;
      $('[data-wheel-code]', dlg).textContent = seg.code;
      $('[data-wheel-apply]', dlg).href = '/discount/' + encodeURIComponent(seg.code) + '?redirect=' + encodeURIComponent(dlg.getAttribute('data-redirect') || '/');
    }
    if (done) { try { var seg0 = JSON.parse(done); showResult(seg0); } catch (e) {} }

    function open() { if (!dlg.open) dlg.showModal(); }
    if (trigger) { trigger.hidden = false; trigger.addEventListener('click', open); }
    if (!done && !ls('br_wheel_seen')) {
      setTimeout(function () { if (!document.querySelector('dialog[open]')) { open(); ls('br_wheel_seen', '1'); } }, (parseInt(dlg.getAttribute('data-delay'), 10) || 12) * 1000);
    }

    $('[data-wheel-copy]', dlg).addEventListener('click', function () {
      var code = $('[data-wheel-code]', dlg).textContent;
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { toast(T.strings.copied); });
    });

    $('[data-wheel-form]', dlg).addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target, email = $('input[type=email]', form), consent = $('[data-wheel-consent]', form), err = $('[data-wheel-error]', form);
      if (!email.value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value) || !consent.checked) { err.hidden = false; return; }
      err.hidden = true;
      var btn = $('button[type=submit]', form); btn.disabled = true;
      // Abonare în Shopify (Clienți → acceptă marketing), etichetă „roata-norocului”
      var fd = new FormData();
      fd.append('form_type', 'customer'); fd.append('utf8', '✓');
      fd.append('contact[email]', email.value); fd.append('contact[tags]', 'newsletter,roata-norocului');
      fd.append('contact[accepts_marketing]', 'true');
      fetch('/contact', { method: 'POST', body: fd }).catch(function () {}).finally(function () {
        // Alegere ponderată a premiului
        var total = segs.reduce(function (a, s) { return a + (s.weight > 0 ? s.weight : 0); }, 0), r = Math.random() * total, idx = 0;
        for (var i = 0; i < n; i++) { r -= segs[i].weight > 0 ? segs[i].weight : 0; if (r <= 0) { idx = i; break; } }
        var target = 360 * 6 + (360 - (idx * step + step / 2));
        svg.style.transition = 'transform 5s cubic-bezier(.12,.67,.12,1)';
        svg.style.transform = 'rotate(' + target + 'deg)';
        setTimeout(function () {
          ls('br_wheel_won', JSON.stringify(segs[idx]));
          showResult(segs[idx]);
          confetti();
        }, 5200);
      });
    });
  }

  /* ---------- Pornire ---------- */
  // Selectează țara implicită în formularele de adresă
  function initCountrySelects() {
    $$('select[data-default]').forEach(function (s) { var v = s.getAttribute('data-default'); if (v) s.value = v; });
  }

  function init() {
    setHeaderHeight();
    initCountrySelects();
    initAnnouncements();
    initCountdowns();
    initProductForms();
    initGalleries();
    initCart();
    initFacets();
    initRecommendations();
    initWheel();
    try { sessionStorage.setItem('br_unlocked', String(unlockedCount(drawer))); } catch (e) {}
  }
  window.addEventListener('resize', setHeaderHeight);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Reinițializare în editorul de temă când se modifică o secțiune
  document.addEventListener('shopify:section:load', function () {
    initAnnouncements(); initCountdowns(); initProductForms(); initGalleries(); initRecommendations(); setHeaderHeight();
  });
})();
